import { typeof as _typeof } from './_virtual/_rollupPluginBabelHelpers.js';
import isArray$1 from 'lodash/isArray';

/**
 * Query an object for a specific key
 *
 * @param object
 * @param query
 * @param defaults
 * @returns {*}
 */

function searchObject(object, query) {
  var defaults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var res = query.split('.').reduce(function (o, i) {
    return o ? o[i] : undefined;
  }, object);
  return typeof res !== 'undefined' ? res : defaults;
}
function queryObject(object, query) {
  var defaults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var current = object;
  var queryParts = query.split(".");
  var part;

  if (object == undefined) {
    return defaults;
  }

  while (current && queryParts.length > 0) {
    part = queryParts.shift();

    if (current[part] == undefined) {
      return defaults;
    }

    current = current[part];
  }

  return current;
}
function setValueByQuery(object, query, value) {
  var parts = query.split(".");
  var key = parts.pop();
  var parentQuery = parts.join(".");
  var parent = parts.length === 0 ? object : queryObject(object, parentQuery);

  if (parent == undefined) {
    setValueByQuery(object, parentQuery, parent = {});
  }

  parent[key] = value;
  return object;
}
/**
 * Pluck specific keys from an object
 *
 * @param object
 * @param keys
 * @returns {{}}
 */

function pluckKeys(object, keys) {
  var newObj = {};
  keys.forEach(function (key) {
    if (key in object) {
      newObj[key] = object[key];
    }
  });
  return newObj;
}
/**
 * Pluck keys except specific from an object
 *
 * @param object
 * @param exceptions
 * @returns {{}}
 */

function pluckKeysExcept(object, exceptions) {
  var keys = Object.keys(object);
  exceptions.forEach(function (key) {
    var index = keys.indexOf(key);

    if (index !== -1) {
      keys.splice(index, 1);
    }
  });
  return pluckKeys(object, keys);
}
function decodeObservable(observable) {
  if (observable == null) {
    return observable;
  } // Check if array like


  if (isArray$1(observable)) {
    return observable.reduce(function (acc, value) {
      acc.push(decodeObservable(value));
      return acc;
    }, []);
  } // Check if object


  if (observable && _typeof(observable) === "object") {
    var decoded = {};
    Object.keys(pluckKeysExcept(observable, ["$mobx"])).forEach(function (key) {
      decoded[key] = decodeObservable(observable[key]);
    });
    return decoded;
  }

  return observable;
}
function cloneObject(obj) {
  if (!obj || _typeof(obj) !== "object") {
    return obj;
  }

  return JSON.parse(JSON.stringify(obj));
}
function empty(obj) {
  var type = _typeof(obj);

  if (type !== 'object') {
    var msg = "Expected param obj to be of type 'object', got ".concat(type);
    throw new TypeError(msg);
  }

  return Object.keys(obj).length === 0 && obj.constructor === Object;
}

export { cloneObject, decodeObservable, empty, pluckKeys, pluckKeysExcept, queryObject, searchObject, setValueByQuery };
//# sourceMappingURL=object.js.map
